import { BsDash } from 'react-icons/bs';
import mazstar from '../../assets/images/mazstar.png';
import { useNavigate } from "react-router-dom";
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';

const IntroductionComponent = () => {

    const navigate = useNavigate();

    return (
        <div className="bg-midnight h-full flex flex-col md:flex-row px-[30px] relative ">
            <div className="md:basis-[50%] lg:basis-[40%]   text-white py-[90px] lg:py-[130px]">
                <Fade top delay={1300}>
                    <p className='flex text-accent items-center text-[16px] font-poppins'><BsDash /> Introduction</p>
                </Fade>
                <Fade  delay={1000}>
                    <div >
                        <h1 className='mt-2 font-montserrat text-[40px] lg:text-[78px] font-[550] lg:font-[600] leading-[1.2] lg:leading-[6rem]'>Hello</h1>
                        <span className=' font-montserrat text-[40px] md:text-[80px] font-[550] lg:font-[600] leading-[1.2] lg:leading-[6rem]'>I'm Hamzat Mazeedah</span>
                        <p className='text:[14px] md:text-[14px] lg:text-[18px] font-poppins mt-2 lg:mt-8 font-[350] tracking-[0.05em] text-ash leading-[1.8]'>Since beginning my journey as a fullstack developer {parseInt(new Date().getFullYear()) - 2021} years ago, I have done remote work for agencies, consulted for startup, and collaborated with talented people to create digital products.</p>
                    </div>
                </Fade>
                <Fade bottom delay={1300} >
                    <div className="w-full md:w-[190px] h-[60px] flex justify-center items-center mt-6 text-primary rounded-[14px] font-montserrat text-[16px] font-[500] cursor-pointer bg-[transparent] bg-gradient-to-r from-secondary to-text  hover:bg-gradient-to-l transition-all duration-[1000ms] whitespace-nowrap shadow-md shadow-text hover:shadow-none" onClick={() => { navigate("/contact") }}
                    >Contact Me</div>
                </Fade>
            </div>
            <div className="md:basis-[50%] lg:basis-[60%] relative mb-16 md:mb-0">
                <Zoom duration={1500}>
                    <div className='mx-auto md:mt-[200px] border-[50px] lg:border-[80px] border-accent h-[300px] w-[300px] md:h-[370px] md:w-[370px] lg:h-[600px] lg:w-[600px] rounded-[50%] md:relative '>
                        <Fade bottom delay={500} duration={1000}>
                            <img src={mazstar} alt="mazstar" className='md:absolute  bottom-0' />
                        </Fade>
                    </div>
                </Zoom>
                <div className='h-[150px] md:h-[150px] lg:h-[300px] md:ml-[2rem] lg:ml-[5rem] w-full md:w-[80%] top-[5rem] md:top-[17rem] absolute  '>
                    <Fade duration={1000} delay={1500}>
                        <div className=' shadow-md shadow-primary rounded-[50%] md:text-[20px] lg:text-[30px] bg-primary flex justify-center items-center w-[70px] h-[70px] lg:w-[110px] lg:h-[110px] text-accent font-poppins absolute top-[-2rem]'>C#</div>
                    </Fade>
                    <Fade duration={1000} delay={1700}>
                        <div className=' shadow-md shadow-primary rounded-[50%] md:text-[20px] lg:text-[30px] bg-primary flex justify-center items-center w-[70px] h-[70px] lg:w-[110px] lg:h-[110px] text-accent font-poppins absolute top-[-2rem] right-0' >Css</div>
                    </Fade>
                    <Fade duration={1000} delay={1900}>
                        <div className=' shadow-md shadow-primary rounded-[50%] md:text-[20px] lg:text-[30px] bg-primary flex justify-center items-center w-[70px] h-[70px] lg:w-[110px] lg:h-[110px] text-accent font-poppins absolute bottom-0 left-[-2rem] md:left-[-3.5rem]'>Js</div>
                    </Fade>
                    <Fade duration={1000} delay={2100}>
                        <div className=' shadow-md shadow-primary rounded-[50%] md:text-[20px] lg:text-[30px] bg-primary flex justify-center items-center w-[70px] h-[70px] lg:w-[110px] lg:h-[110px] text-accent font-poppins absolute bottom-0 right-[-2rem] md:right-[-3.5rem]'>.net</div>
                    </Fade>
                </div>

            </div>
        </div>
    );
}

export default IntroductionComponent;